import React, { useState, useEffect, useRef, useMemo } from "react";
import "./ProductPage.css";
import { Link, useLocation } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import { API } from "../../services/api";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCart } from "../../contextPage/CartContext";
import { useUser } from "../../contextPage/UserContext";



const getPaginationPages = (currentPage, totalPages, delta = 2) => {
    const pages = [];
    const range = [];

    const start = Math.max(2, currentPage - delta);
    const end = Math.min(totalPages - 1, currentPage + delta);

    range.push(1);

    if (start > 2) {
        range.push("...");
    }

    for (let i = start; i <= end; i++) {
        range.push(i);
    }

    if (end < totalPages - 1) {
        range.push("...");
    }

    if (totalPages > 1) {
        range.push(totalPages);
    }

    return range;
};


const normalizeImages = (images) => {
    if (!images) return [];

    // if API already returns array
    if (Array.isArray(images)) return images;

    // if it's a JSON string
    if (typeof images === "string") {
        try {
            const parsed = JSON.parse(images);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            // if stored as "a.jpg,b.jpg"
            if (images.includes(",")) {
                return images.split(",").map(s => s.trim()).filter(Boolean);
            }
            // single filename string
            return [images];
        }
    }

    return [];
};
/* ---------- Options shown in the top filter bar ---------- */
const PRICE_OPTIONS = [
    { value: "under-999", label: "Under ₹999" },
    { value: "1000-2500", label: "₹1,000 - ₹2,500" },
    { value: "5000-7500", label: "₹5,000 - ₹7,500" },
    { value: "below-10k", label: "Below ₹10,000" },
    { value: "10k-20k", label: "₹10,000 - ₹20,000" },
    { value: "20k-50k", label: "₹20,000 - ₹50,000" },
    { value: "above-50k", label: "Above ₹50,000" },
];

const CATEGORY_OPTIONS = [
    "Rings", "Necklaces", "Earrings", "Bracelets", "Chain", "Pendents",
    "Men's Jewellery", "Solitaries", "Anklets", "Nose Ring", "Bangles", "Kada",
].map(v => ({ value: v, label: v }));
const TYPE_OPTIONS = ["Men", "Women", "Kids", "Unisex"].map(v => ({ value: v, label: v }));
// const COLLECTION_OPTIONS = ["CZ Collections", "GOD Pendants", "Cuban Collection"]
//     .map(v => ({ value: v, label: v }));
const COLLECTION_OPTIONS = [
    "CZ Collections",
    "GOD Pendants",
    "Cuban Collection",
].map(v => ({ value: v, label: v }));

// 👇 add special filter option
COLLECTION_OPTIONS.push({
    value: "__include_out_of_stock__",
    label: "Include Out of Stock"
});
/* ---------- Reusable dropdown with checkboxes ---------- */
function FilterDropdown({ label, filterType, options, selected = [], onToggle }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onDocClick = (e) => {
            if (open && ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, [open]);


    useEffect(() => {
        const setOffsets = () => {
            const nav = document.querySelector('.nav-shell .nav-inner');
            const promo = document.querySelector('.nav-promo-bar'); // not sticky, but we’ll include if you ever make it sticky
            const navH = nav ? nav.getBoundingClientRect().height : 0;
            const promoH = 0; // promo isn’t sticky; keep 0. Change to: (promo?.getBoundingClientRect().height || 0) if you make it sticky.
            document.documentElement.style.setProperty('--nav-h', `${navH + promoH}px`);
        };
        setOffsets();
        window.addEventListener('resize', setOffsets);
        return () => window.removeEventListener('resize', setOffsets);
    }, []);
   
    

    return (
        <div className="filter-dd" ref={ref}>
            <button
                type="button"
                className={`filter-dd-btn ${selected.length ? "active" : ""}`}
                onClick={() => setOpen((s) => !s)}
            >
                {label} {selected.length ? <span className="dd-count">{selected.length}</span> : <span className="dd-caret">▾</span>}
            </button>

            {open && (
                <div className="filter-dd-menu">
                    <ul>
                        {options.map((opt) => {
                            const checked = selected.includes(opt.value);
                            return (
                                <li key={opt.value}>
                                    <label className="dd-option">
                                        <input
                                            type="checkbox"
                                            checked={checked}
                                            onChange={() => onToggle(filterType, opt.value)}
                                        />
                                        <span>{opt.label}</span>
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
}

const ProductPage = () => {
    const [filters, setFilters] = useState({ price: [], category: [], type: [], collection: [] });
    const [products, setProducts] = useState([]);
    const [sortOrder, setSortOrder] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 12;
    const location = useLocation();
    const searchParams = useMemo(
        () => new URLSearchParams(location.search),
        [location.search]
    );

    const preselectedCategory = searchParams.get("category");
    const preselectedType = searchParams.get("type");
    const preselectedCollection = searchParams.get("collection");
    const preselectedPrice = searchParams.get("price");
    const preselectedSearch = searchParams.get("search"); // ✅ SEARCH
    const preselectedTag = searchParams.get("tag"); // ✅ tag filter (handmade, kidshandmade, mobhandy, mobhandmade)

    const formatProductName = (name = "") => {
        const lower = name.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    };


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [adding, setAdding] = useState(false);
    const [added, setAdded] = useState(false);
    const [showAddedModal, setShowAddedModal] = useState(false);
   
    const navigate = useNavigate();
    const formatINR = (n) => {
        const v = Number(n);
        if (Number.isNaN(v)) return "—";
        return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
    };


      const { addToCart, cart, loadCart } = useCart();
        const { isLoggedIn, loadingUser, reloadUser } = useUser();
    


    // button states per product id
    const [addedIds, setAddedIds] = useState(new Set());
    const [addingIds, setAddingIds] = useState(new Set());

 
    const [selectedProduct, setSelectedProduct] = useState(null);

    
        
        const descRef = useRef(null);
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && setShowAddedModal(false);
        if (showAddedModal) document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [showAddedModal]);


    useEffect(() => {
        if (!showAddedModal) return;

        // Close with Esc + auto-dismiss after 10s
        const onKey = (e) => e.key === "Escape" && setShowAddedModal(false);
        document.addEventListener("keydown", onKey);

        const timer = setTimeout(() => setShowAddedModal(false), 10000);

        return () => {
            document.removeEventListener("keydown", onKey);
            clearTimeout(timer);
        };
    }, [showAddedModal]);

    const handleAddToCart = async (e, prod) => {
        e?.preventDefault();
        e?.stopPropagation();
        if (loadingUser) return;

        if (!isLoggedIn) {
            const token = localStorage.getItem("token");
            if (token && typeof reloadUser === "function") {
                await reloadUser();
            }
        }
        if (!isLoggedIn) {
            toast.info("Please login to add products to cart");
            navigate("/login");
            return;
        }

        const qtyToAdd = 1; // listing page adds +1 each click

        const snapshot = {
            productName: prod.productName ?? prod.name,
            unitPrice: Number(prod.displayPrice ?? prod.cost ?? prod.price ?? 0) || 0,
            images: normalizeImages(prod.images ?? prod.image ?? []),
        };

        setAddingIds((s) => new Set(s).add(prod.id));
        const res = await addToCart(prod.id, qtyToAdd, null, snapshot);
        setAddingIds((s) => {
            const n = new Set(s);
            n.delete(prod.id);
            return n;
        });

        const ok = res?.ok ?? res === true;
        const unauthorized = res?.unauthorized;

        if (res?.alreadyInCart) {
            setSelectedProduct(prod);
            setShowAddedModal(true);
            toast.info("This product is already in your cart");
            return;
        }

        if (ok) {
            setAddedIds((s) => new Set(s).add(prod.id));
            setSelectedProduct(prod);        // for modal content
            setShowAddedModal(true);         // open modal
            toast.success("Added to cart");
        } else if (unauthorized) {
            toast.info("Session expired. Please login again.");
            navigate("/login");
        } else {
            toast.error("Failed to add to cart. Please try again.");
        }
    };


    

    // fetch products + apply preselected filters from query
    useEffect(() => {
        setLoading(true);
        fetch(API.getProducts)
            .then((res) => {
                if (!res.ok) throw new Error("API error");
                return res.json();
            })
            .then((data) => {
                if (!Array.isArray(data)) {
                    console.error("Expected array but got:", data);
                    setProducts([]);
                    return;
                }

                const normalizedProducts = data.map((product) => {
                    // If product has variants → ignore parent quantity
                    if (product.variants && product.variants.length > 0) {
                        return {
                            ...product,
                            quantity: null
                        };
                    }

                    // If no variants → create single virtual variant
                    return {
                        ...product,
                        variants: [
                            {
                                id: `single-${product.id}`,
                                size: null,
                                quantity: Number(product.quantity || 0),
                            }
                        ]
                    };
                });

                setProducts(normalizedProducts);

                const initial = { price: [], category: [], type: [], collection: [] };
                if (preselectedPrice) initial.price.push(preselectedPrice);
                // category = Product type (e.g. Kada, Bangles). type = Shop for (e.g. Men, Women, Kids).
                if (preselectedCategory) initial.category.push(preselectedCategory);
                if (preselectedType) initial.type.push(preselectedType);
                if (preselectedCollection) initial.collection.push(preselectedCollection);

                setFilters(initial);
                setError(null);
            })
            .catch((err) => {
                console.error("Product fetch failed:", err);
                setError("Failed to load products");
            })
            .finally(() => setLoading(false));
    }, [preselectedPrice, preselectedCategory, preselectedType, preselectedCollection]);

    // toggle one value in a filter (used by dropdowns)
    const toggleOption = (filterType, value) => {
        setCurrentPage(1);
        setFilters((prev) => {
            const exists = prev[filterType].includes(value);
            const updated = exists ? prev[filterType].filter((v) => v !== value) : [...prev[filterType], value];
            return { ...prev, [filterType]: updated };
        });
    };

    const removeFilterTag = (filterType, value) => {
        setFilters((prev) => ({
            ...prev,
            [filterType]: prev[filterType].filter((item) => item !== value),
        }));
    };

    const clearAllFilters = () => {
        setFilters({ price: [], category: [], type: [], collection: [] });
        if (preselectedTag) {
            const params = new URLSearchParams(location.search);
            params.delete("tag");
            navigate(location.pathname + (params.toString() ? `?${params.toString()}` : ""));
        }
    };
    const normalize = (str) => (str || "").toLowerCase().trim();
    const searchText = normalize(preselectedSearch);
    const suggestedSearch = searchText
        ?.split(" ")
        .map(word => (word.endsWith("s") ? word.slice(0, -1) : word))
        .join(" ");


    const highlightText = (text, query) => {
        if (!query) return text;

        const words = query
            .split(" ")
            .filter(Boolean)
            .map(w => (w.endsWith("s") ? w.slice(0, -1) : w));

        const regex = new RegExp(`(${words.join("|")})`, "gi");

        return text.split(regex).map((part, i) =>
            words.includes(part.toLowerCase())
                ? <mark key={i}>{part}</mark>
                : part
        );
    };

   /* ---------- filtering ---------- */
    // const filteredProducts = products.filter((product) => {
    //     const normalize = (str) => (str || "").toLowerCase().trim();

    //     const matchPrice =
    //         !filters.price.length ||
    //         filters.price.some((range) => {
    //             const price = parseFloat(product.cost);
    //             switch (range) {
    //                 case "under-999": return price < 999;
    //                 case "1000-2500": return price >= 1000 && price <= 2500;
    //                 case "5000-7500": return price >= 5000 && price <= 7500;
    //                 case "below-10k": return price < 10000;
    //                 case "10k-20k": return price >= 10000 && price <= 20000;
    //                 case "20k-50k": return price > 20000 && price <= 50000;
    //                 case "above-50k": return price > 50000;
    //                 default: return false;
    //             }
    //         });

    //     const matchCategory =
    //         !filters.category.length ||
    //         filters.category.map(normalize).includes(normalize(product.category));

    //     const matchType =
    //         !filters.type.length ||
    //         filters.type.map(normalize).includes(normalize(product.type));

    //     const matchCollection =
    //         !filters.collection.length ||
    //         filters.collection.map(normalize).includes(normalize(product.collection));

    //     return matchPrice && matchCategory && matchType && matchCollection;
    // });
    const filteredProducts = products.filter((product) => {

        const includeOutOfStock = filters.collection.includes("__include_out_of_stock__");

        // Compute stock the same way everywhere:
        // if variants exist, sum variant.quantity; otherwise use product.quantity.
        const hasVariants = Array.isArray(product.variants) && product.variants.length > 0;
        const productStock = hasVariants
            ? product.variants.reduce(
                (sum, v) => sum + Number(v?.quantity || 0),
                0
            )
            : Number(product.quantity || 0);
        if (!includeOutOfStock && productStock <= 0) {
            return false;
        }
        const words = searchText.split(" ").filter(Boolean);

        const matchSearch =
            !searchText ||
            words.every((word) => {
                const w = word.endsWith("s") ? word.slice(0, -1) : word;

                const strictRegex = new RegExp(`\\b${w}\\b`, "i");

                const strictMatch =
                    strictRegex.test(product.productName || "") ||
                    strictRegex.test(product.category || "") ||
                    strictRegex.test(product.type || "");

                const looseMatch =
                    normalize(product.tags || "").includes(w) ||
                    normalize(product.collection || "").includes(w) ||
                    normalize(product.sku || "").includes(w);

                return strictMatch || (looseMatch && !strictRegex.test("earring"));

            });


        const matchPrice =
            !filters.price.length ||
            filters.price.some((range) => {
                const price = parseFloat(product.displayPrice);
                switch (range) {
                    case "under-999": return price < 999;
                    case "1000-2500": return price >= 1000 && price <= 2500;
                    case "5000-7500": return price >= 5000 && price <= 7500;
                    case "below-10k": return price < 10000;
                    case "10k-20k": return price >= 10000 && price <= 20000;
                    case "20k-50k": return price > 20000 && price <= 50000;
                    case "above-50k": return price > 50000;
                    default: return false;
                }
            });

        const matchCategory =
            !filters.category.length ||
            filters.category.map(normalize).includes(normalize(product.category));

        const matchType =
            !filters.type.length ||
            filters.type.map(normalize).includes(normalize(product.type));

        // const matchCollection =
        //     !filters.collection.length ||
        //     filters.collection.map(normalize).includes(normalize(product.collection));
        const realCollectionFilters = filters.collection.filter(
            v => v !== "__include_out_of_stock__"
        );

        const matchCollection =
            !realCollectionFilters.length ||
            realCollectionFilters
                .map(normalize)
                .includes(normalize(product.collection));

        // Tag filter from URL (?tag=handmade etc.): match product.tags and product.otherTags (e.g. "handmade,Handmade")
        const tagsStr = Array.isArray(product.tags)
            ? (product.tags || []).join(",")
            : (product.tags || "");
        const otherTagsStr = Array.isArray(product.otherTags)
            ? (product.otherTags || []).join(",")
            : (product.otherTags || "");
        const allTagsNormalized = normalize([tagsStr, otherTagsStr].filter(Boolean).join(","));
        const tagValue = (preselectedTag || "").trim().toLowerCase();

        // Handmade filter: when tag=handmade (any case), match any handmade-style tags
        let matchTag = true;
        if (tagValue) {
            if (tagValue === "handmade") {
                const handmadeKeywords = [
                    "handmade",
                    "mobhandmade",
                    "kidshandmade",
                    "mobhandy",
                ];
                matchTag = handmadeKeywords.some((kw) =>
                    allTagsNormalized.includes(kw)
                );
            } else {
                matchTag = allTagsNormalized.includes(tagValue);
            }
        }

        return (
            matchSearch &&
            matchPrice &&
            matchCategory &&
            matchType &&
            matchCollection &&
            matchTag
        );
    });

    const showDidYouMean =
        searchText &&
        filteredProducts.length === 0 &&
        suggestedSearch &&
        suggestedSearch !== searchText;

    const sortedProducts = [...filteredProducts];
    if (sortOrder === "low-high") sortedProducts.sort((a, b) => parseFloat(a.displayPrice) - parseFloat(b.displayPrice));
    if (sortOrder === "high-low") sortedProducts.sort((a, b) => parseFloat(b.displayPrice) - parseFloat(a.displayPrice));

    const paginatedProducts = sortedProducts.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(sortedProducts.length / itemsPerPage);
    
    useEffect(() => {
        if (currentPage > totalPages) {
            setCurrentPage(1);
        }
    }, [totalPages]);
    
    
    
    const selectedImgUrl = useMemo(() => {
        if (!selectedProduct) return null;

        const arr = normalizeImages(selectedProduct.images);
        const first = arr?.[0];

        return first
            ? `${API.imagePath}${first}`
            : "/fallback.png";   // local fallback
    }, [selectedProduct]);
  
    useEffect(() => {
        setCurrentPage(1);
    }, [location.search]);


    return (
        <>
            <div className="container">
                {/* -------- Top Filter Bar + Sort -------- */}
                <div className="top-filter-bar">
                    <div className="top-filter-row">
                        <FilterDropdown
                            label="Product type"
                            filterType="category"
                            options={CATEGORY_OPTIONS}
                            selected={filters.category}
                            onToggle={toggleOption}
                        />
                        <FilterDropdown
                            label="Price"
                            filterType="price"
                            options={PRICE_OPTIONS}
                            selected={filters.price}
                            onToggle={toggleOption}
                        />
                        <FilterDropdown
                            label="Shop For"
                            filterType="type"
                            options={TYPE_OPTIONS}
                            selected={filters.type}
                            onToggle={toggleOption}
                        />
                        <FilterDropdown
                            label="Collections"
                            filterType="collection"
                            options={COLLECTION_OPTIONS}
                            selected={filters.collection}
                            onToggle={toggleOption}
                        />

                        <button className="clear-all" onClick={clearAllFilters} disabled={
                            !preselectedTag && !filters.price.length && !filters.category.length && !filters.type.length && !filters.collection.length
                        }>
                            Clear All
                        </button>

                        <div className="sort-inline">
                            <label>SORT BY:</label>
                            <select onChange={(e) => setSortOrder(e.target.value)} value={sortOrder}>
                                <option value="">Default</option>
                                <option value="low-high">Price: Low to High</option>
                                <option value="high-low">Price: High to Low</option>
                            </select>
                        </div>
                    </div>

                    {/* Selected tags: show filter label so "Kids" appears as "Shop For", not "Product type" */}
                    <div className="selected-tags">
                        {preselectedTag && (
                            <span className="tag" key="tag-filter">
                                Tag: {preselectedTag}
                                <button
                                    onClick={() => {
                                        const params = new URLSearchParams(location.search);
                                        params.delete("tag");
                                        navigate(location.pathname + (params.toString() ? `?${params.toString()}` : ""));
                                    }}
                                >
                                    ×
                                </button>
                            </span>
                        )}
                        {[
                            ...filters.price.map((v) => ({ type: "price", value: v, label: "Price" })),
                            ...filters.category.map((v) => ({ type: "category", value: v, label: "Product type" })),
                            ...filters.type.map((v) => ({ type: "type", value: v, label: "Shop For" })),
                            ...filters.collection.map((v) => ({ type: "collection", value: v, label: "Collection" }))
                        ].filter((f) => f.value && f.value !== "__include_out_of_stock__").map((f) => (
                            <span className="tag" key={`${f.type}-${f.value}`}>
                                {f.label}: {f.value}
                                <button onClick={() => removeFilterTag(f.type, f.value)}>×</button>
                            </span>
                        ))}
                    </div>
                </div>
            </div>
            {preselectedSearch && (
                <div className="search-heading container">
                    Showing results for "<strong>{preselectedSearch}</strong>"
                </div>
            )}
            {showDidYouMean && (
                <div className="did-you-mean container">
                    Did you mean{" "}
                    <button
                        onClick={() =>
                            navigate(`/products?search=${encodeURIComponent(suggestedSearch)}`)
                        }
                    >
                        {suggestedSearch}
                    </button>
                    ?
                </div>
            )}

            <div className="product-pagep container">
                {/* No sidebar anymore — products full width */}
                <main className="products">
                    {loading ? (
                        <p>Loading products...</p>
                    ) : error ? (
                        <p>{error}</p>
                    ) : paginatedProducts.length > 0 ? (
                        paginatedProducts.map((product) => {
                            const hasVariants = Array.isArray(product.variants) && product.variants.length > 0;
                            const productStock = hasVariants
                                ? product.variants.reduce(
                                    (sum, v) => sum + Number(v?.quantity || 0),
                                    0
                                )
                                : Number(product.quantity || 0);
                            const isOutOfStock = productStock <= 0;
                            const { id, cost } = product;
                            const parsedImages = normalizeImages(product.images);
                            const imageUrl = parsedImages[0] ? `${API.imagePath}${parsedImages[0]}` : "/fallback.avif";
                            const secondUrl = parsedImages[1] ? `${API.imagePath}${parsedImages[1]}` : imageUrl;
                            
                            // Resolve a stable display price; do NOT drop to 0 just because it's out of stock
                            const rawPrice =
                                product.displayPrice ??
                                product.cost ??
                                product.price ??
                                0;
                            const costValue = Number(rawPrice) || 0;
                            const discountPct = Number(product.discountcost) || 0;
                            const discountedValue = Math.max(0, Math.round(costValue * (1 - discountPct / 100)));

                            return (
                                <Link to={`/product/${id}`} key={id} className="product-cardp">
                                    {/* <div className="product-image-wrap">
                                        <img
                                            loading="lazy"
                                            src={imageUrl}
                                            alt={`${product.productName} - ₹${cost}`}
                                            className="product-imagep"
                                            onError={(e) => (e.currentTarget.src = "https://via.placeholder.com/150")}
                                        />

                                        {Number(product.quantity) < 2 && (
                                            <span className="badge low-stock">Only Few Left!</span>
                                        )}
                                    </div> */}
                                    <div className="product-image-wrap">
                                        {isOutOfStock && (
                                            <span className="badge out-stock">Out of Stock</span>
                                        )}
                                        {/* <img
                                            loading="lazy"
                                            src={imageUrl}
                                            alt={`${product.productName} - ₹${cost}`}
                                            className="product-imagep primary"
                                            onError={(e) => (e.currentTarget.src = "/fallback.avif")}
                                        /> */}
                                        <img
                                            loading="lazy"
                                            src={imageUrl}
                                            alt={`${product.productName} - ₹${cost}`}
                                            className={`product-imagep primary ${isOutOfStock ? "out-stock-img" : ""}`}
                                            onError={(e) => (e.currentTarget.src = "/fallback.avif")}
                                        />
                                        {/* second image (fallbacks to first if not available) */}
                                        <img
                                            loading="lazy"
                                            src={parsedImages[1] ? `${API.imagePath}${parsedImages[1]}` : imageUrl}
                                            alt={`${product.productName} - alternate view`}
                                            className="product-imagep secondary"
                                            onError={(e) => (e.currentTarget.src = imageUrl || "/fallback.avif")}
                                        />

                                        {Number(product.quantity) < 2 && (
                                            <span className="badge low-stock">Only Few Left!</span>
                                        )}
                                    </div>


                                    {/* <p className="productprice pri">₹{parseFloat(cost).toLocaleString()}</p> */}
                                    <div className="price-blockp">
                                        {discountPct > 0 ? (
                                            <>
                                                <span className="final">₹{formatINR(discountedValue)}</span>
                                                <span className="strike">₹{formatINR(costValue)}</span>
                                                <span className="off-badge">{discountPct}% OFF</span>
                                            </>
                                        ) : (
                                            <span className="final">₹{formatINR(costValue)}</span>
                                        )}
                                    </div>

                                    {/* <h4 className="productname pri">{product.productName}</h4> */}
                                    <h4 className="productname pri product-title">
                                        {highlightText(formatProductName(product.productName), searchText)}
                                    </h4>


                                    {/* <button
                                        type="button"
                                        className={`buynow ${addedIds.has(id) ? "added" : ""}`}
                                        onClick={(e) => handleAddToCart(e, product)}
                                        disabled={loadingUser || addingIds.has(id)}
                                    >
                                        {addingIds.has(id)
                                            ? "ADDING..."
                                            : addedIds.has(id)
                                                ? "ADDED TO CART"
                                                : "ADD TO CART"}
                                    </button> */}
                                    <button
                                        type="button"
                                        className={`buynow ${addedIds.has(id) ? "added" : ""}`}
                                        onClick={(e) => handleAddToCart(e, product)}
                                        disabled={loadingUser || addingIds.has(id) || isOutOfStock}
                                    >
                                        {isOutOfStock
                                            ? "OUT OF STOCK"
                                            : addingIds.has(id)
                                                ? "ADDING..."
                                                : addedIds.has(id)
                                                    ? "ADDED TO CART"
                                                    : "ADD TO CART"}
                                    </button>

                                </Link>

                            );
                        })
                    ) : (
                                    <p><b>Coming Soon</b></p>
                    )}
                </main>
            </div>

            {/* <div className="custom-pagination">
                {totalPages > 1 && (
                    <div className="pagination-buttons">
                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index + 1}
                                className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </button>
                        ))}
                    </div>
                )}
            </div> */}
            <div className="custom-pagination">
                {totalPages > 1 && (
                    <div className="pagination-buttons">
                        {getPaginationPages(currentPage, totalPages).map((page, index) => (
                            page === "..." ? (
                                <span key={index} className="dots">...</span>
                            ) : (
                                <button
                                    key={page}
                                    className={`page-btn ${currentPage === page ? "active" : ""}`}
                                    onClick={() => {
                                        setCurrentPage(page);

                                        // 👇 scroll to top smoothly
                                        window.scrollTo({
                                            top: 0,
                                            behavior: "smooth",
                                        });
                                    }}
                                >
                                    {page}
                                </button>
                            )
                        ))}
                    </div>
                )}
            </div>

            {showAddedModal && selectedProduct && (
                <div className="added-toast" role="dialog" aria-live="polite" aria-atomic="true">
                    <button className="added-toast-close" aria-label="Close" onClick={() => setShowAddedModal(false)}>×</button>
                    <div className="added-toast-body">
                        <img
                            src={selectedImgUrl}
                            alt={selectedProduct.productName}
                            className="added-toast-img"
                            onError={(e) => (e.currentTarget.src = "/fallback.png")}
                        />
                        <div className="added-toast-text">
                            <h4>Added to Cart</h4>
                            <p><strong>{selectedProduct.productName}</strong> has been added successfully.</p>
                            <div className="added-toast-actions">
                                <button className="btn small" onClick={() => setShowAddedModal(false)}>Continue Shopping</button>
                                <button className="btn primary small" onClick={() => navigate("/cart")}>Go to Cart</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <Footer />
        </>
    );
};

export default ProductPage;
